<template>
  <div class="task-inline-detail">
    <task-edit
      :id="id"
      :detailParams="detailParams"
      :read-only="!!(detailParams && detailParams.readOnly)"
      @close-form="onClose"
      @task-done="$emit('task-done', $event)"
    />
  </div>
</template>

<script>
import TaskEdit from './TaskEdit.vue'

export default {
  name: 'TaskInlineDetail',
  components: {
    'task-edit': TaskEdit
  },
  props: {
    id: { required: true },
    detailParams: { type: Object, default: () => ({}) }
  },
  methods: {
    onClose () { this.$emit('close-form') }
  }
}
</script>
